import React from 'react';

// The decorative backdrop behind the "play" button on the video guides thumbnail.
export const VideoThumbnailIllustration = ({mobile}) => (
    <svg
        width="480" height="272" viewBox="0 0 480 272" aria-hidden="true"
        preserveAspectRatio={mobile ? 'xMidYMid slice' : undefined}
        style={{position: 'absolute', inset: 0, width: '100%', height: '100%'}}
    >
        <g opacity="0.55">
            <ellipse cx="120" cy="80" rx="54" ry="20" fill="none" stroke="#30A46C" strokeWidth="2"/>
            <ellipse cx="250" cy="140" rx="54" ry="20" fill="none" stroke="#F5A524" strokeWidth="2"/>
            <ellipse cx="370" cy="200" rx="54" ry="20" fill="none" stroke="#E5484D" strokeWidth="2"/>
            <path d="M174 84 C 210 84, 190 140, 196 140 M304 144 C 340 144, 320 200, 316 200" fill="none"
                  stroke="#6B6A72" strokeWidth="2"/>
        </g>
    </svg>
);
